export default __webpack_public_path__ + "static/media/1.8ebd0a42.png";